'use client';

import { useTranslationStore } from '@/stores';
import { useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation as t } from '../../../hooks/useTranslation';
import { IEpSelectOptionsListData } from '../../../interfaces';
import { EpStepContent, EpStepSelect } from '../components';
import { notificationService } from '../../../services/notificationService';
import { useHospitalStore } from '../../../stores';
import { usePathname, useSearchParams } from 'next/navigation';
import { EpLoading } from '../../EpLoading';

export default function PatientDocumentType({
  translations,
  isPharmacy,
}: {
  translations: unknown;
  isPharmacy: boolean;
}) {
  const { setValue } = useFormContext();
  const { hospitalInfo } = useHospitalStore((state) => state);
  const searchParams = useSearchParams();
  const hospitalIdParams =
    searchParams?.get?.('HospitalId') || searchParams?.get?.('hospitalId');
  const savedHospitalId = hospitalIdParams || hospitalInfo?.HospitalId;

  const pathname = usePathname();
  const isPublicPath = pathname.includes('Public');

  const { getDocumentType, getDocumentTypePublic } = notificationService;
  const { data: dataPrivate , isLoading:isLoadingPrivate } = getDocumentType(
    hospitalInfo?.HospitalId as string,
    !isPublicPath,
  );
  const { data: dataPublic, isLoading: isLoadingPublic } = getDocumentTypePublic(
    savedHospitalId as string,
    isPublicPath,
  );

  const isLoading =isPublicPath ? isLoadingPublic : isLoadingPrivate;
  const data = isPublicPath ? dataPublic : dataPrivate;
  const PersonValue = useWatch({ name: 'person.inputValue' });
  const NoId = useWatch({ name: 'noId' });
  const personType = useWatch({ name: 'personType.inputValue' });
  const activeStep = useWatch({ name: 'formUtils.activeStep' });
  const checkIfIsPersonValid =
    (PersonValue === 'true' || PersonValue === undefined) && !!NoId;
  const checkIfIsPersonType = (personType && personType === '1') || isPharmacy;
  const isVisible = checkIfIsPersonValid || checkIfIsPersonType;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [DocumentTypeItens, setDocumentTypeItems] =
    useState<IEpSelectOptionsListData[]>();

  const { translations: global } = useTranslationStore();

  useEffect(() => {
    if (data) {
      setDocumentTypeItems(data);

      setValue('IdentificationType.inputValue', data[0].id.toString());
      setValue('IdentificationType.inputLabel', data[0].name);
    }

    // setDocumentTypeItems(data);
  }, [data, activeStep, personType]);

  if (!isVisible) return null;

  if (!isLoading && (!DocumentTypeItens || DocumentTypeItens.length === 0)) {
    return null;
  }

  return (
    <div style={{ width: `250px` }}>
      <EpStepContent.Label
        label={t(translations, 'Patient identification type')}
      >
        {isLoading ?
        <EpLoading
          size='sm'
          isVisible
          position='relative'
          loadingType='card'
          loadingId='loading-patient-doc-type'
          style={{
            top: '25px',
          }}
          /> :
          <EpStepSelect
          required={false}
          data={DocumentTypeItens as IEpSelectOptionsListData[]}
          // defaultValue={1}
          // disabled={DocumentTypeItens.length <= 1}
          errorMessage={t(global['global'], '* Required Fied')}
          registerId={'IdentificationType'}
        />}
        
      </EpStepContent.Label>
    </div>
  );
}
